module.exports = __webpack_public_path__ + "img/go-offficial.510896f6.svg";